export default class DocumentDetailsController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.stateParams = this.injector.get('$stateParams');
        this.api = this.injector.get('$http');
        this.navService = this.injector.get('NavService');
        this.usersStore = this.injector.get('Users');
        this.acl = this.injector.get('Acl');
        this.fileSaver = this.injector.get('FileSaver');
        this.blob = this.injector.get('Blob');
        this.resourceCommon = this.injector.get('ResourceCommon');
        this.pusher = null;

        this.pdfData = null;
        this.pdfLoading = true;

        this._initPusher();
        this._loadModel().then(() => {

        });
    }

    _initPusher() {
        this.usersStore.dispatch('getLoggedIn').then((loggedIn) => {
            this.pusher = this.usersStore.state.pusher;
            this.pusher.bind('document-pdf-status-update', (data) => {
                if (parseInt(this.stateParams.id) === data.document_id) {
                    this._loadModel();
                }
            });

            this.scope.$on('$destroy', () => {
                this.pusher.unbind('document-pdf-status-update');
            });
        });
    }

    _loadModel() {
        return this.api.get(`documents/${this.stateParams.id}`).then((response) => {
            this.document = response.data.data;
            if (this.document.pdf_status === 'generated') {
                this._loadPdfData();
            }
            this._prepareNavigationInformation();
        }, () => {
            this.alert.error('Error', 'Error while loading document');
            this.state.back();
        });
    }

    _loadPdfData() {
        this.pdfLoading = true;
        return this.api.get(this.document.pdf_file.url, {responseType: "arraybuffer"})
            .then((response) => {
                this.pdfData = new Uint8Array(response.data);
                this.pdfLoading = false;
            }, (response) => {
                this.alert.warning('PDF Error', 'Error while getting data for document preview');
            });
    }

    _prepareNavigationInformation() {
        const sideNavActions = [];

        if (this.document && this.document.pdf_status === 'generated' && this.acl.hasRight('documents::download')) {
            sideNavActions.push({
                key: 'download-document',
                title: 'Download',
                icon: 'download',
                action: () => {
                    this.api.get(this.document.pdf_file.url, {responseType: "blob"})
                        .then(response => {
                            const blob = new this.blob([response.data], {type: response.headers('content-type')});
                            this.loading = false;

                            this.fileSaver.saveAs(blob, this.document.pdf_file.name);
                        }, response => {

                        });
                }
            });
        }

        if (this.document
            && this.document.pdf_status === 'generated'
            && this.acl.hasRight('documents::send')
            && this.document.relations.length === 1
            && this.document.relations[0].relation_type === 'contacts') {
            sideNavActions.push({
                key: 'send-document',
                title: 'Send',
                icon: 'envelope',
                action: () => {
                    return this.api.get(`contacts/${this.document.relations[0].relation_id}`).then((contactResponse) => {
                        return this.resourceCommon.selectEmailTemplate(false, _.get(contactResponse, 'data.data', null)).then((data) => {
                            return this.api.post(`documents/${this.document.id}/send`, {
                                contact_id: this.document.relations[0].relation_id,
                                template_id: data.template.id,
                                send_to_override: data.send_to_override
                            }).then(() => {
                                this.alert.success('Messages scheduled', 'The messages was scheduled');
                            }, err => this.alert.handle(err))
                        });
                    })
                }
            });
        }

        this.navService.overrideMainSideNavActions(sideNavActions);
    }
}

DocumentDetailsController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/documents/controllers/main/details-controller.js